import { render, staticRenderFns } from "./TutorialModal.vue?vue&type=template&id=48418f88&scoped=true"
var script = {}
import style0 from "./TutorialModal.vue?vue&type=style&index=0&id=48418f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48418f88",
  null
  
)

export default component.exports